<section class="login">
  <div class="login__card">
    <div class="login__info">
      <h1 class="login__header">
        {{labels.title}}
      </h1>
      <div class="login__about">
        <ul class="login__list">
          @for (item of labels.list; track item) {
          <li class="login__list-item">
            {{item}}
          </li>
          }
        </ul>
      </div>
    </div>
    <mat-divider class="login__divider" [vertical]="true"></mat-divider>
    <div class="login__auth">
      <app-passport-chooser [passports]="passports" (passport)="onPassportAuthenticate($event)" class="login__passport"></app-passport-chooser>
      <!--
      <mat-divider class="login__divider" [vertical]="false"></mat-divider>
      <button mat-button class="login__button button button_primary" (click)="onAuthenticate()">
        {{labels.button}}
      </button>
      -->
    </div>
  </div>
</section>

